<template>
    <v-container pa-0 mt-1 v-if="companyEmailList.length > 0">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Distribution List Filters
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-flex xs12 v-for="(item, index) in tags" :key="index">
                        <v-autocomplete
                            clearable
                            :items="tagOptions[item.id]"
                            item-text="tagDetail"
                            return-object
                            :label="item.name"
                            v-model="tagSelections[index]"
                        />
                    </v-flex>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-flex xs12>
            <v-autocomplete
                clearable
                :items="companyEmailListSelect"
                v-model="selectedCompanyEmailList"
                item-text="emailListName"
                item-value="companyEmailListId"
                label="Distribution List"
                autocomplete="off"
            />
        </v-flex>
    </v-container>
</template>

<script>
import axios from 'axios'
import { authHeader } from '../_helpers'

export default {
    data() {
        return {
            companyEmailList: [],
            selectedCompanyEmailList: null,
            tags: [],
            tagSelections: [],
            tagOptions: {},
            usedTagIds: []
        }
    },
    computed: {
        companyEmailListSelect() {
            let filteredList = [...this.companyEmailList]
            for (let tagIdx = 0; tagIdx < this.tagSelections.length; tagIdx++) {
                let selectedTag = this.tagSelections[tagIdx]
                if (selectedTag !== undefined) {
                    let listsToRemove = []
                    for (let i = 0; i < filteredList.length; i++) {
                        if (filteredList[i].tags.hasOwnProperty(selectedTag.tagId)) {
                            let toRemove = filteredList[i].tags[selectedTag.tagId] !== selectedTag.tagDetail
                            if (toRemove) {
                                listsToRemove.push(i)
                            }
                        } else {
                            listsToRemove.push(i)
                        }
                    }
                    filteredList = filteredList.filter(function(value, i) {
                        return !listsToRemove.includes(i)
                    })
                }
            }
            return filteredList
        }
    },
    methods: {
        getCompanyEmailLists() {
            axios
                .get(
                    this.$store.state.companyEmailListUrl +
                        '/' +
                        this.$store.state.authentication.loggedInUser.companyId,
                    {
                        headers: authHeader()
                    }
                )
                .then(response => {
                    if (response.data.length > 0) {
                        let usedTagIds = []
                        for (let index = 0; index < response.data.length; index++) {
                            let listData = response.data[index]
                            let _data = {
                                companyEmailListId: listData.companyEmailListId,
                                emailListName: listData.listName,
                                companyEmailListDetail: listData.companyEmailListDetail
                            }
                            let tags = {}
                            for (let i = 0; i < listData.tagDetails.length; i++) {
                                let tagDetailObj = {
                                    tagId: listData.tagDetails[i].tagId,
                                    tagDetail: listData.tagDetails[i].tagDetailContent
                                }
                                tags[tagDetailObj.tagId] = tagDetailObj.tagDetail

                                if (!this.tagOptions[tagDetailObj.tagId]) {
                                    usedTagIds.push(tagDetailObj.tagId)
                                    this.tagOptions[tagDetailObj.tagId] = []
                                    this.tagOptions[tagDetailObj.tagId].push(tagDetailObj)
                                } else {
                                    let foundTagIndex = this.tagOptions[tagDetailObj.tagId].indexOf(
                                        tag => tag.tagDetail === tagDetailObj.tagDetail
                                    )
                                    if (foundTagIndex < 0) {
                                        this.tagOptions[tagDetailObj.tagId].push(tagDetailObj)
                                    }
                                }
                            }
                            _data.tags = tags
                            this.companyEmailList.push(_data)
                        }
                        this.getAllTags(usedTagIds)
                    }
                })
                .catch(error => {
                    console.log(error)
                    let snackbarParams = {
                        message: error.message,
                        context: 'error'
                    }
                    this.$store.commit('showSnackbar', snackbarParams)
                })
        },
        getAllTags(usedTagIds) {
            let params = {
                tagIds: usedTagIds
            }
            axios
                .get(this.$store.state.tagUrl + '/getByIds', {
                    headers: authHeader(),
                    params
                })
                .then(response => {
                    this.tags = []
                    for (let tag of response.data) {
                        this.tags.push({ id: tag.tagId, name: tag.tagName })
                        this.tagSelections.push(undefined)
                    }
                })
                .catch(error => {
                    console.log(error)
                    let snackbarParams = {
                        message: error.message,
                        context: 'error'
                    }
                    this.$store.commit('showSnackbar', snackbarParams)
                })
        }
    },
    watch: {
        selectedCompanyEmailList() {
            if (this.selectedCompanyEmailList) {
                //list selected
                this.$emit('clearLists')
                let chosenEmailList = this.companyEmailList.find(record => {
                    return record.companyEmailListId === this.selectedCompanyEmailList
                })
                for (let index = 0; index < chosenEmailList.companyEmailListDetail.length; index++) {
                    const record = chosenEmailList.companyEmailListDetail[index]
                    this.$emit('addEmailToListWithVars', record.email, record.cc, record.superApprover)
                }
            } else {
                //reset as no list selected
                this.$emit('clearLists')
            }
        }
    },
    created() {
        this.getCompanyEmailLists()
    }
}
</script>
